import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { Store } from './redux/store'
import { QueryClientProvider } from 'react-query'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import Routes from './routes'
import { GlobalStyles } from './GlobalStyles'
import queryClient from './services/request/queryClient'
import GlobalActions from './GlobalActions'

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={Store}>
        <BrowserRouter>
          <GlobalStyles />
          <GlobalActions />
          <Routes />
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  )
}

export default App
